import bus from '../util/eventBus';

document.addEventListener('DOMContentLoaded', () => {
  const contactPersonEl = document.getElementById('contact-person');
  const contactPersonTrigger = document.getElementById(
    'contact-person-trigger',
  );
  const shareBtn = contactPersonEl.querySelector('.c-contact__share-btn');

  if (contactPersonEl) {
    const headerControls = document.getElementById('headerControls');
    const filterEl = headerControls.querySelector('.c-contact__filter-select');
    const contactPersons = contactPersonEl.querySelectorAll('.c-person');

    // Filter functionality
    if (filterEl) {
      filterEl.addEventListener('change', e => {
        e.preventDefault();

        const contactPersonsListItems = contactPersonEl.querySelectorAll(
          '.c-nav__item--filterable',
        );

        contactPersonsListItems.forEach(item => {
          const itemEl = item;
          const markets = itemEl.dataset.market.split(',');

          if (markets.includes(filterEl.value) || filterEl.value === '') {
            itemEl.classList.remove('is-hidden');
          } else {
            itemEl.classList.add('is-hidden');
          }
        });
      });
    }

    // Selection Functionalities
    if (contactPersons) {
      let currentPerson = null;

      contactPersons.forEach(person => {
        const personEl = person;
        const { vcfLink } = personEl.dataset;
        const cardTrigger = personEl.querySelector('.c-person__card-trigger');

        cardTrigger.addEventListener('click', () => {
          const { postId } = personEl.dataset;

          if (personEl.classList.contains('is-expanded')) {
            currentPerson = null;
          } else {
            currentPerson = postId;
          }

          const notThis = Array.prototype.slice
            .call(contactPersons)
            .filter(p => p.dataset.postId !== currentPerson);

          personEl.classList.toggle('is-expanded');

          if (currentPerson) {
            headerControls.classList.add('is-expanded');
            shareBtn.setAttribute('href', vcfLink);
          } else {
            headerControls.classList.remove('is-expanded');
          }

          notThis.forEach(card => card.classList.remove('is-expanded'));
        });
      });
    }

    // Select on Parameters
    const urlQueryString = window.location.search;
    const urlParams = new URLSearchParams(urlQueryString);
    const paramContactPerson = urlParams.get('contact_person');

    if (paramContactPerson) {
      const personEl = document.querySelector(
        `[data-person-slug="${paramContactPerson}"]`,
      );

      if (personEl) {
        [contactPersonEl, contactPersonTrigger].forEach(el =>
          el.classList.add('is-active'),
        );
        const { vcfLink } = personEl.dataset;

        shareBtn.setAttribute('href', vcfLink);
        [personEl, headerControls].forEach(el =>
          el.classList.add('is-expanded'),
        );

        const contactPopupBody = contactPersonEl.querySelector(
          '.c-popup__body',
        );

        contactPopupBody.scrollBy({
          left: 0,
          top:
            personEl.getBoundingClientRect().y -
            contactPopupBody.getBoundingClientRect().y,
          behavior: 'smooth',
        });
      }
    }

    // Select on Grid click
    const triggerContactPerson = teaseElements => {
      teaseElements.forEach(tease => {
        const triggerEl = tease.querySelector('[class*="trigger"]');
        const { viewContact } = triggerEl.dataset;
        const personEl = document.querySelector(
          `[data-person-slug="${viewContact}"]`,
        );

        if (personEl) {
          const { vcfLink } = personEl.dataset;
          triggerEl.addEventListener('click', () => {
            shareBtn.setAttribute('href', vcfLink);

            contactPersons.forEach(el => {
              const { personSlug } = el.dataset;
              if (personSlug !== viewContact)
                el.classList.remove('is-expanded');
            });

            if (!contactPersonTrigger.classList.contains('is-active')) {
              contactPersonTrigger.click();
            }

            [personEl, headerControls].forEach(el => {
              el.classList.add('is-expanded');
            });

            const contactPopupBody = contactPersonEl.querySelector(
              '.c-popup__body',
            );

            contactPopupBody.scrollBy({
              left: 0,
              top:
                personEl.getBoundingClientRect().y -
                contactPopupBody.getBoundingClientRect().y,
              behavior: 'smooth',
            });
          });
        }
      });
    };

    const inlinePersons = document.querySelectorAll('.c-person--inline');

    if (inlinePersons) {
      triggerContactPerson(inlinePersons);
    }

    let personTease = document.querySelectorAll('.c-tease--contact-person');

    if (personTease) {
      setTimeout(() => triggerContactPerson(personTease), 0);

      bus.on('ewg-grid-recalculated', () => {
        personTease = document.querySelectorAll('.c-tease--contact-person');
        setTimeout(() => triggerContactPerson(personTease), 0);
      });

      bus.on('ewg-load-more', () => {
        personTease = document.querySelectorAll('.c-tease--contact-person');
        setTimeout(() => triggerContactPerson(personTease), 0);
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/contactPerson.js